import * as React from 'react';
import './ExpandableScroll.css';

interface IExpandableScrollState {
  isExpanded: boolean;
  isOverflowing: boolean;
}

class ExpandableScroll extends React.Component<{ children: React.ReactNode }, IExpandableScrollState> {
  private contentRef: React.RefObject<HTMLDivElement>;

  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = {
      isExpanded: false,
      isOverflowing: false,
    };
    this.contentRef = React.createRef();
  }

  public componentDidMount() {
    this.checkOverflow();
  }

  public componentDidUpdate() {
    this.checkOverflow();
  }

  public checkOverflow = () => {
    const content = this.contentRef.current;
    const collapsedMaxHeight = 160;

    if (content && content.scrollHeight > collapsedMaxHeight) {
      if (!this.state.isOverflowing) {
        this.setState({ isOverflowing: true });
      }
    } else if (this.state.isOverflowing) {
      this.setState({ isOverflowing: false });
    }
  };

  public toggleContent = () => {
    this.setState((prevState) => ({
      isExpanded: !prevState.isExpanded,
    }));
  };

  public render() {
    const { isExpanded, isOverflowing } = this.state;
    const { children } = this.props;

    return (
      <div className="scroll-wrapper">
        <div
          ref={this.contentRef}
          className={`scroll-content ${isExpanded ? 'expanded' : 'collapsed'}`}
        >
          {children}
        </div>
        {isOverflowing && (         
         <div className="showmoreless"onClick={this.toggleContent}>
            {isExpanded ? 'Show Less' : 'Show More'}
        </div>
        )}
      </div>
    );
  }
}

export default ExpandableScroll;
